<div class="flex-container">
  <app-mask [mask]="mask" [color]="'#f3f3f3'"></app-mask>
    <!-- Primer item -->
    <div class="item">
      <div class="image-column" (click)="selectReportingBtn('hoursInactive',atm.sensorRadar.id,'presencia','no_trans')">
        <img src="../assets/icons/no_transactions.svg" [class.selected-mode-btn]="btnSelected === 'no_trans'" class="image">
      </div>
      <div class="text-column">
        <div class="row1">
          Horas sin transaccionar:
        </div>
        <div class="row2">
          {{reportData?.hoursInactive}}
        </div>
      </div>
    </div>
  
    <!-- Segundo item -->
    <div class="item">
      <div class="image-column" (click)="selectReportingBtn('hoursActive',atm.sensorRadar.id,'presencia','trans')">
        <img src="../assets/icons/transactions_active.svg" [class.selected-mode-btn]="btnSelected === 'trans'" class="image" >
      </div>
      <div class="text-column">
        <div class="row1">
           Horas transaccionando: 
        </div>
        <div class="row2">
           {{reportData?.hoursActive}} 
        </div>
      </div>
    </div>
  
    <!-- Tercer item -->
    <div class="item">
      <div class="image-column" (click)="selectReportingBtn('numberTransactions',atm.sensorRadar.id,'presencia','num_trans')">
        <img src="../assets/icons/transactions_number.svg" [class.selected-mode-btn]="btnSelected === 'num_trans'" class="image" >
      </div>
      <div class="text-column">
        <div class="row1">
           Numero de transacciones: 
        </div>
        <div class="row2">
           {{reportData?.numberTransactions}} 
        </div>
      </div>
    </div>
  
    <!-- Cuarto item -->
    <div class="item">
      <div class="image-column" (click)="selectReportingBtn('countOpenVault',atm.sensorVault.id,'boveda','vault')">
        <img src="../assets/icons/open_vault.svg" [class.selected-mode-btn]="btnSelected === 'vault'" class="image" >
      </div>
      <div class="text-column">
        <div class="row1">
           Boveda abierta 
        </div>
        <div class="row2">
           {{reportData?.countOpenVault || 0}} eventos 
        </div>
      </div>
    </div>
  
    <!-- Quinto item -->
    <div class="item">
      <div class="image-column" (click)="selectReportingBtn('timeForUser',atm.sensorRadar.id,'presencia','time')">
        <img src="../assets/icons/prom_time_user.svg" [class.selected-mode-btn]="btnSelected === 'time'" class="image" >
      </div>
      <div class="text-column">
        <div class="row1">
           Tiempo promedio por usuario: 
        </div>
        <div class="row2">
           {{reportData?.timeForUser}} segundos 
        </div>
      </div>
    </div>
  </div>